module.exports = __webpack_public_path__ + "img/undTooth8.e9fa4348.png";